import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Alert,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useChangeOrganisationName } from "../../hooks/useOrganisations";
import { useSnackbar } from "../../contexts/SnackbarContext";

const ChangeOrganisationNameButton = ({ organisationId, currentName }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const { showSuccess, showError } = useSnackbar();

  const changeNameMutation = useChangeOrganisationName();

  const handleOpen = () => {
    setName(currentName || "");
    setOpen(true);
  };

  const handleSubmit = () => {
    if (!name.trim()) {
      showError("Organisation name cannot be empty");
      return;
    }

    if (name.trim() === currentName) {
      showError("New name must be different from current name");
      return;
    }

    changeNameMutation.mutate(
      {
        organisationId: parseInt(organisationId),
        name: name.trim(),
      },
      {
        onSuccess: () => {
          showSuccess("Organisation name changed successfully");
          handleClose();
        },
        onError: (error) => {
          showError(
            `Failed to change organisation name: ${
              error.response?.data?.detail || error.message
            }`
          );
        },
      }
    );
  };

  const handleClose = () => {
    setOpen(false);
    setName("");
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<Edit />}
        onClick={handleOpen}
        size="small"
      >
        Change Name
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Change Organisation Name</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Organisation Name"
            type="text"
            fullWidth
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter new organisation name"
            sx={{ mt: 2 }}
          />

          {changeNameMutation.isError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              Failed to change name: {changeNameMutation.error?.message}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={
              !name.trim() ||
              name.trim() === currentName ||
              changeNameMutation.isPending
            }
          >
            {changeNameMutation.isPending ? (
              <CircularProgress size={20} />
            ) : (
              "Change Name"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ChangeOrganisationNameButton;
